// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__37ott","insightsList":"newBusinessInsightsMenu_insightsList__15HP8","active":"newBusinessInsightsMenu_active__1pnw7"};